import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { schema, schemaProps } from "./schema"
import { useAppDispatch, useAppSelector } from "store/hooks";
import { useCallback, useEffect, useId, } from "react";
import { getClientICP, updateClientICP } from "store/slices/icp.slice";
import { toastHelper } from "utils/helper";
import { errorMessages, infoMessages, successMessages } from "utils/message";

export const useMinimunScore = () => {
    const dispatch = useAppDispatch()
    const { data, updateClientICP: updateData } = useAppSelector((state) => state.icp);
    const id = useId()
    const form = useForm({
        defaultValues: {
            icp: data?.thresholdMinimumIcp || 20,
            behavior: data?.thresholdMinimumBehavior || 20
        },
        resolver: zodResolver(schema)
    })
    const handleSubmit = useCallback((value: schemaProps) => {
        toastHelper({ toastId: id, message: infoMessages.SAVING_DATA, type: 'info' })
        const data: any = {
            thresholdBehavior: value.behavior,
            thresholdIcp: value.icp,
        }
        try {
            dispatch(updateClientICP({ ...data })).unwrap().then(() => {
                toastHelper({ toastId: id, message: successMessages.UPDATE_SUCCESS, type: 'success' })
            })
        } catch (error) {
            toastHelper({ toastId: id, message: errorMessages.SOMETHING_WENT_WRONG, type: 'error' })
        }
    }, [])
    useEffect(() => {
        dispatch(getClientICP())
            .unwrap()
            .then(data => {
                form.setValue('icp', data.data.thresholdMinimumIcp)
                form.setValue('behavior', data.data.thresholdMinimumBehavior)
            });
    }, []);

    const isDisabled = data?.thresholdMinimumBehavior === form.watch('behavior') && data?.thresholdMinimumIcp === form.watch('icp')
    return { form, isLoading: updateData.isLoading, isDisabled, handleSubmit }
}